var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1659_4148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.25 2.5H3.75C2.75544 2.5 1.80161 2.89509 1.09835 3.59835C0.395088 4.30161 0 5.25544 0 6.25L0 33.75C0 34.7446 0.395088 35.6984 1.09835 36.4016C1.80161 37.1049 2.75544 37.5 3.75 37.5H14.4727V25.6008H9.55078V20H14.4727V15.7312C14.4727 10.8758 17.3633 8.19375 21.7906 8.19375C23.9109 8.19375 26.1281 8.57188 26.1281 8.57188V13.3375H23.6852C21.2781 13.3375 20.5273 14.8312 20.5273 16.3633V20H25.9008L25.0414 25.6008H20.5273V37.5H31.25C32.2446 37.5 33.1984 37.1049 33.9016 36.4016C34.6049 35.6984 35 34.7446 35 33.75V6.25C35 5.25544 34.6049 4.30161 33.9016 3.59835C33.1984 2.89509 32.2446 2.5 31.25 2.5Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1659_4148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.dc340400c82c9b1481d6e378b1b74e53.svg";
export { ForwardRef as ReactComponent };